import { DevicesControlState } from './states/devices-control.state';

export const devicesControlState = [DevicesControlState];
